import '../../../assets/styles/yaongsnack.scss';

import { useContext } from 'react';
import useSWRInfinite from 'swr/infinite';
import { AuthContext } from '../../../context/AuthContext';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/arrow_left.svg';
import { useNavigate } from 'react-router';
import SnakImg from '../../../assets/images/new_main/img-snak-big.png';
import SnackList from '../../../components/SnackList';
import { InView } from 'react-intersection-observer';
import useSWR from 'swr';

const PAGE_CNT = 10;

export default function YaongSnak() {
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const navigate = useNavigate();

  // 페이징 처리: 1페이지 10개씩
  const getKey = (pageIndex, previousPageData) => {
    if (!accessToken) return null;
    if (previousPageData && (!previousPageData.list || previousPageData.list.length === 0)) return null;
    return [`${API_SERVER_DOMAIN}/game/egg/snackHistory?page=${pageIndex + 1}&rowPerPage=${PAGE_CNT}`, accessToken];
  };

  const { data, size, setSize, isLoading, isValidating } = useSWRInfinite(getKey, fetchWithToken);

  // 야옹에그 정보
  const { data: eggData } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}/game/egg/userGameInfo`, accessToken],
    fetchWithToken,
  );

  // 전체 리스트 합치기
  const snackList = data ? data.flatMap((page) => page.list || []) : [];
  const totalCount = data && data[0] ? data[0].totalCount : 0;
  const isReachingEnd =
    data && data[data.length - 1] && (!data[data.length - 1].list || data[data.length - 1].list.length < PAGE_CNT);

  if (isLoading && !data) return null;

  return (
    <section className='yaong-game-container'>
      <div className='page-header header-shadow'>
        <ArrowIcon onClick={() => navigate('/playground')} style={{ left: 24 }} />
        <h3>내가 모은 간식</h3>
      </div>

      {/* 간식 박스 상단 */}
      <div className='content-container'>
        <div className='snack-header'>
          <div className='snack-box'>
            <img src={SnakImg} alt={'snak-icon'} width={65} height={54} />
            <div className='label'>
              <span>보유중</span>
            </div>
            <div className='cnt-box'>
              <span>{eggData?.userEggGameInfo?.snackCount ?? 0}개</span>
            </div>
          </div>
        </div>
      </div>
      <div className='divider' />
      {/* 간식 내역 */}
      <div className='snack-content' style={{ overflowY: 'auto', maxHeight: '60vh' }}>
        <div className='label'>내역</div>
        <SnackList data={snackList} />
        {/* 무한 스크롤 트리거 */}
        {!isReachingEnd && (
          <InView
            as='div'
            onChange={(inView) => {
              if (inView && !isValidating) {
                setSize(size + 1);
              }
            }}
          >
            <div style={{ height: 30, textAlign: 'center', color: '#aaa' }}>
              {isValidating ? '불러오는 중...' : '더 불러오기'}
            </div>
          </InView>
        )}
      </div>
    </section>
  );
}
